import formatters from 'common/utils/periods.formatters';

class ScheduleMobileController {
  constructor($window, modalCalendarGridService, vacationUserDataService) {
    'ngInject';
    this.modalCalendarGridService = modalCalendarGridService;
    this.window = $window;
    this.UserDataService = vacationUserDataService;

    this.isMobileApp = $window.innerWidth < 1024;
    this.isMobileSchedule = true;
    this.dateToday = new Date();
  }

  $onInit(){
    this.userId = this.UserDataService.getEmployee().userId;

    this.scheduleData = {};

    this.modalCalendarGridService.getRequestModalPeriods(this.userId).then((response) => {
      this.scheduleData.vacationPeriods = response.data;
      this.scheduleData.absencePeriods = [];
      this.scheduleData.periodInDays = formatters.formatPeriodInDays(this.scheduleData.vacationPeriods);
      this.loaded = true;
    });
  }
}

export default ScheduleMobileController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/scheduleMobile/scheduleMobile.controller.js